var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66665 20.2119H4.70841C4.52053 20.2119 4.34034 20.1373 4.20749 20.0044C4.07464 19.8716 4 19.6914 4 19.5035V15.5453C3.99968 15.4533 4.0175 15.3621 4.05245 15.277C4.0874 15.192 4.13879 15.1146 4.20367 15.0494L14.8298 4.42325C14.8957 4.35632 14.9743 4.30316 15.0609 4.26688C15.1476 4.2306 15.2406 4.21191 15.3345 4.21191C15.4285 4.21191 15.5215 4.2306 15.6081 4.26688C15.6948 4.30316 15.7734 4.35632 15.8393 4.42325L19.7887 8.37263C19.8556 8.43855 19.9088 8.51712 19.945 8.60377C19.9813 8.69043 20 8.78343 20 8.87737C20 8.97131 19.9813 9.06432 19.945 9.15097C19.9088 9.23762 19.8556 9.3162 19.7887 9.38211L9.16253 20.0082C9.09733 20.0731 9.01996 20.1245 8.93487 20.1595C8.84978 20.1944 8.75863 20.2122 8.66665 20.2119Z",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.501 6.75195L17.4598 11.7108",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bd278fd74086ddc4157d0f2eb7d2e0ef.svg";
export { ForwardRef as ReactComponent };